// extracted by mini-css-extract-plugin
export default {"base":"CjRJb","description":"V6Z6h","priority_0":"m40uL","priority_1":"ttLPt","priority_2":"xIIjm"};